import type { SessionUser } from 'shared/context/AuthContext'

/**
 * Three auth states, kept distinct.
 *
 * AuthContext models the session as `SessionUser | null | undefined`, where `undefined`
 * means "not resolved yet" and `null` means "resolved, nobody is signed in". A truthiness
 * check (`if (!user)`) collapses those two and is what makes a signed-in user briefly see
 * signed-out UI. Use this instead.
 */
export type AuthState = 'resolving' | 'anonymous' | 'authenticated'

export const getAuthState = (user: SessionUser | null | undefined): AuthState => {
  if (user === undefined) return 'resolving'
  if (user === null) return 'anonymous'
  return 'authenticated'
}
